import React from 'react';

const Input = (props) => (
  <input {...props} className="input" />
);

export { Input };
